import React from 'react';
import PropTypes from 'prop-types';
import { toIntlDateTimeFormat } from '@zedoc/date';
import compact from 'lodash/compact';

export const formatCompletedAt = ({ t, language, completedAt }) => {
  if (!completedAt) {
    return null;
  }

  return `${t('completedAt')} ${toIntlDateTimeFormat(language, completedAt, {
    dateStyle: 'short',
    timeStyle: 'short',
  })}`;
};

export const joinDocumentParts = (parts) =>
  compact(parts)
    .map((part) => part.trim())
    .filter(Boolean)
    .join(', ');

const SECONDARY_LINE_CLASS =
  'text-sm text-secondary leading-snug line-clamp-1 mt-0.5';

const DocumentRow = ({ primaryLine, secondaryLine, tertiaryLine, actions }) => {
  return (
    <div className="cluster-4 items-center justify-between flex-wrap gap-y-2 py-2">
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-sm leading-snug line-clamp-2">
          {primaryLine}
        </p>
        {secondaryLine && (
          <p className={SECONDARY_LINE_CLASS}>{secondaryLine}</p>
        )}
        {tertiaryLine && <p className={SECONDARY_LINE_CLASS}>{tertiaryLine}</p>}
      </div>
      <div className="cluster-2 items-center flex-wrap shrink-0">{actions}</div>
    </div>
  );
};

DocumentRow.propTypes = {
  primaryLine: PropTypes.string.isRequired,
  secondaryLine: PropTypes.string,
  tertiaryLine: PropTypes.string,
  actions: PropTypes.node,
};

DocumentRow.defaultProps = {
  secondaryLine: null,
  tertiaryLine: null,
  actions: null,
};

export default DocumentRow;
